import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAchievements } from '../../api/hooks';
import { Medallion } from './Medallion';
import { ShieldIcon } from './icons';
import { ShowcaseEditorSheet } from './ShowcaseEditorSheet';
import { track } from '../../analytics';

/**
 * Витрина достижений в профиле (PF1): до 3 закреплённых медальонов.
 * У владельца — «Редактировать» (bottom-sheet V1) и пустые слоты-пунктиры;
 * у гостя — только закреплённое и ссылка в read-only каталог.
 */
export function ShowcaseCard({ pid }: { pid: number | null }) {
  const summary = useAchievements(pid);
  const [editorOpen, setEditorOpen] = useState(false);
  const isOwner = pid === null;

  if (summary.isLoading) {
    return <div className="skeleton" style={{ height: 132, borderRadius: 18, marginBottom: 14 }} />;
  }
  if (!summary.data) return null;

  const s = summary.data;
  const base = isOwner ? '/achievements' : `/players/${pid}/achievements`;
  const slots: (typeof s.showcase[number] | null)[] = [...s.showcase];
  while (slots.length < 3) slots.push(null);

  return (
    <div className="ach-showcase">
      <div className="ach-showcase-head">
        <span className="ach-overline ach-overline--gold">Витрина достижений</span>
        {isOwner && (
          <button
            className="ach-showcase-edit"
            onClick={() => {
              setEditorOpen(true);
              track('showcase_editor_open', {});
            }}
          >
            Редактировать
          </button>
        )}
      </div>

      {s.showcase.length === 0 && !isOwner ? (
        <div className="ach-showcase-empty">Игрок ещё не закрепил достижения</div>
      ) : (
        <div className="ach-showcase-slots">
          {slots.map((item, i) =>
            item ? (
              <Link
                key={item.id}
                className="ach-showcase-slot"
                to={`${base}/${item.id}`}
                onClick={() => track('achievement_open', { id: item.id, from: 'showcase' })}
              >
                <Medallion icon={item.icon} level={item.level} maxLevel={item.maxLevel}
                  progress={null} state={item.state} size={58} glow />
                <span>{item.name}</span>
              </Link>
            ) : isOwner ? (
              <button key={`empty-${i}`} className="ach-showcase-slot ach-showcase-slot--empty"
                onClick={() => setEditorOpen(true)}>
                <span className="plus">+</span>
              </button>
            ) : (
              <span key={`empty-${i}`} className="ach-showcase-slot ach-showcase-slot--void" />
            ),
          )}
        </div>
      )}

      <div className="ach-showcase-foot">
        <span className="pts">
          <ShieldIcon /> {s.points} очков
        </span>
        <Link className="all" to={base} onClick={() => track('achievements_open', { from: 'profile' })}>
          {isOwner ? `Все достижения ${s.doneCount}/${s.totalCount} →` : `Все ${s.doneCount} →`}
        </Link>
      </div>

      {isOwner && editorOpen && <ShowcaseEditorSheet onClose={() => setEditorOpen(false)} />}
    </div>
  );
}
